const PUBLIC_SITE_PATHS = [
  '/',
  '/about',
  '/contact',
  '/features',
  '/faq',
  '/resources',
  '/organizations',
  '/privacy',
  '/terms',
  '/eula',
  '/schedule-a',
  '/schedule-b',
  '/providers',
  '/security',
  '/loginOrCreateAccount',
  '/signUp',
] as const;

export type PublicSitePath = (typeof PUBLIC_SITE_PATHS)[number];

const PUBLIC_SITE_PATH_SET = new Set<string>(PUBLIC_SITE_PATHS.map((path) => path.toLowerCase()));

const normalizePathname = (pathname: string): string => {
  if (pathname === '/') return pathname;
  return pathname.replace(/\/+$/, '').toLowerCase();
};

/**
 * Public pages are deliberately enumerated so only known marketing, legal,
 * and account-choice routes can render without Clerk. Auth callbacks,
 * invitations, registration, and application routes fail closed into the
 * Clerk-backed application.
 */
export const isPublicSitePath = (pathname: string): boolean =>
  PUBLIC_SITE_PATH_SET.has(normalizePathname(pathname));

export { PUBLIC_SITE_PATHS };
